import { useEffect, useMemo } from "react";
import { getTrackingData, isHTMLElement } from "../utils";
import Logger from "@cappelendamm/logger";
import { TrackingEvent } from "../types";
import { useTrackEvent } from "../TrackingContext";
import { usePathname } from "next/navigation";

export const useTrackIntersectionObserver = <Event extends TrackingEvent>(
  event?: Event | null,
  enabled = true,
  selector = '[data-track-viewport="true"]',
) => {
  const trackEvent = useTrackEvent();
  const pathname = usePathname();
  const payload = useMemo(() => JSON.stringify(event), [event]);
  useEffect(() => {
    const observers: IntersectionObserver[] = [];
    try {
      document.querySelectorAll(selector).forEach((item) => {
        const observer = new IntersectionObserver(
          (entry) => {
            if (
              entry.some(({ isIntersecting }) => isIntersecting) &&
              isHTMLElement(item) &&
              enabled
            )
              trackEvent({
                eventName: "in_viewport",
                pathname,
                ...getTrackingData(item),
                ...JSON.parse(payload),
              });
          },
          {
            threshold: 0.1,
          },
        );
        observer.observe(item);
        observers.push(observer);
      });
    } catch (e) {
      Logger.error(e);
    }
    return () => {
      observers.forEach((observer) => observer.disconnect());
    };
  }, [pathname, selector, payload, enabled, trackEvent]);
};
